import {
  RateWithDetails,
  BranchLecturerRatesGroupDB,
} from '../../../../../api/types/lecturers/user-details-lecturer';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';

/**
 * Converts a RateWithDetails object to the format expected by UserPageLecturerRateItem
 */
export const convertRateWithDetailsToRatesGroup = (
  rateWithDetails: RateWithDetails,
): BranchLecturerRatesGroupDB => {
  return {
    settingsActivityTypeId: rateWithDetails.settingsActivityTypeId,
    activityName: rateWithDetails.activityName,
    paymentType: rateWithDetails.paymentType,
    branchId: rateWithDetails.branchId,
    branchName: rateWithDetails.branchName,
    rates: [rateWithDetails], // Single rate wrapped in array
  };
};

/**
 * Converts a RateWithDetails object to a UserSummaryType object
 */
export const convertRateWithDetailsToUserSummary = (
  rateWithDetails: RateWithDetails,
): UserSummaryType => {
  return {
    id: rateWithDetails.userId,
    firstName: rateWithDetails.firstName,
    lastName: rateWithDetails.lastName,
    nationalId: rateWithDetails.nationalId,
    // For the dialog display, we only need these basic fields
    // The rest can be empty/default values since they're not used in the rate item component
    phoneNumber: '',
    dateOfBirth: new Date(),
    email: '',
    fileUrl: '',
    city: '',
    street: '',
    houseNumber: '',
    flatNumber: '',
    postcode: '',
    gender: 'male' as any,
    immigrateCountry: null,
    immigrateDate: null,
    maritalStatus: 'single' as any,
    role: 'lecturer' as any,
  };
};
